import type { Conversation } from "./types";

export function countUnreadConversations(conversations: Conversation[]) {
  return conversations.filter((conversation) => conversation.unreadCount > 0).length;
}

export function isDemoConversation(conversation: Conversation) {
  return conversation.source === "demo"
    || (conversation.id.startsWith("pilot-") && conversation.tags.includes("piloto-controlado"));
}

export function excludeDemoConversations(conversations: Conversation[]) {
  return conversations.filter((conversation) => !isDemoConversation(conversation));
}

export function conversationsNeedingDetail(
  remote: Conversation[],
  current: Conversation[],
  limit = 50,
) {
  const currentById = new Map(current.map((conversation) => [conversation.id, conversation]));
  return remote
    .filter((conversation) => {
      const existing = currentById.get(conversation.id);
      return !existing
        || existing.updatedAt !== conversation.updatedAt
        || existing.messages.length === 0;
    })
    .slice(0, limit);
}

export function mergeRemoteConversations(
  remote: Conversation[],
  current: Conversation[],
  details: Map<string, Conversation>,
) {
  const currentById = new Map(current.map((conversation) => [conversation.id, conversation]));
  return remote.map((conversation) =>
    details.get(conversation.id)
      ?? currentById.get(conversation.id)
      ?? conversation,
  );
}
